module.exports = __webpack_public_path__ + "img/commitment_figure.c79e7b55.jpg";